import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppProvider, useApp } from '@/state/AppContext';
import { AppSchil } from '@/components/layout/AppSchil';
import { Laadvlak } from '@/components/ui/Feedback';
import { KaartPagina } from '@/pages/KaartPagina';
import { DashboardPagina } from '@/pages/DashboardPagina';
import { InlogScherm } from '@/pages/InlogScherm';

/**
 * Laat het inlogscherm zien zolang er niemand is ingelogd. In mockmodus is er
 * altijd een demo-gebruiker, dus daar zie je dit scherm nooit.
 */
function Beveiligd(): JSX.Element {
  const { gebruiker, authGecontroleerd } = useApp();

  if (!authGecontroleerd) {
    return <Laadvlak tekst="Even kijken of je al ingelogd bent..." />;
  }

  if (!gebruiker) {
    return <InlogScherm />;
  }

  return (
    <AppSchil>
      <Routes>
        <Route path="/" element={<KaartPagina />} />
        <Route path="/dashboard" element={<DashboardPagina />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppSchil>
  );
}

/**
 * HashRouter in plaats van BrowserRouter: de app wordt als losse bestanden
 * gepubliceerd, zonder server die routes kan herschrijven.
 */
export function App(): JSX.Element {
  return (
    <HashRouter>
      <AppProvider>
        <Beveiligd />
      </AppProvider>
    </HashRouter>
  );
}
